import React from "react";
import {
  EditPageContainer,
  Page,
  withServerErrors,
  required,
} from "components/common";
import { FormGroup, SaveButton } from "components/common/Forms";
import GetBack from "components/refactoring/BackButton";
import { compose, withState, withHandlers, lifecycle } from "recompose";
import qs from "query-string";
import { LocalForm, Control, actions } from "react-redux-form";
import { Trans } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Col, Row } from "reactstrap";

export const CompanyEdit = ({
  t,
  mode,
  item,
  form,
  onBack,
  setDispatch,
  onSubmit: onSubmitProp,
  onUpdate,
  onChange,
  roles,
  renderServerError,
  readOnly,
  redirectUrl,
  onDisconnected,
  onDropAccepted,
  onLogoLoad,
  onLogoError,
  Errors,
}) => {
  // const { organisationsQuery } = useOrganisationContext();

  const history = useHistory();

  async function onSubmit(...args) {
    await onSubmitProp(...args);
    // await organisationsQuery.refetch();
    setTimeout(() => {
      history.push(`/core/company`);
    }, 1500);
  }
  return (
    <Page title={`${mode} Company`}>
      <GetBack styleClass="my-2"/>
      <LocalForm
        initialState={item}
        onSubmit={onSubmit}
        getDispatch={setDispatch}
        onUpdate={onUpdate}
        onChange={onChange}
        validators={{
          name: { required },
        }}
      >
        <FormGroup label="Name *" model=".name">
          <Control.text model=".name" placeholder="A company name." />
        </FormGroup>

        <FormGroup label="Tax number *" model=".tax_number">
          <Control.text model=".tax_number" placeholder="Add tax number" />
        </FormGroup>
        <FormGroup label="Contact number *" model=".contact_number">
          <Control.text model=".tax_number" placeholder="Add contact number" />
        </FormGroup>
        <FormGroup label="Email *" model=".email">
          <Control.text model=".email" placeholder="Add contact emial" />
        </FormGroup>
        <FormGroup label="Country *" model=".country">
          <Control.text model=".country" placeholder="Add country" />
        </FormGroup>
        
        {renderServerError("name")}
        
        <FormGroup className="my-3 d-flex justify-content-end">
          <SaveButton className="px-3 m-0" form={form} hidden={readOnly} />
        </FormGroup>

      </LocalForm>
    </Page>
  );
};

const enhance = compose(
  withServerErrors(),
  EditPageContainer({
    url: "core/company",
    defaultItem: { name: "", active: true, },
  }),
  withState("serverErrors", "setServerErrors", {}),
  withState("redirectUrl", "setRedirectUrl", null),
  withHandlers({
  }),
  lifecycle({
    componentDidMount() {
      Promise.resolve().then(() => {
        const q = qs.parse(this.props.location.search);
        if (q.oauth_verifier && q.oauth_token && q.org)
          this.props.verify(q.oauth_token, q.oauth_verifier, q.org);
      });
    },
  })
);

export default enhance(CompanyEdit);
